import { axiosAccess, axiosROW, axiosApplication } from "@config/axiosConfig";
import { ApplicationDetailsPayload } from "@modules/application-section/application-details/types";

export const getApplicationDetails = async (
  payload: ApplicationDetailsPayload
) => {
  const { access_id } = payload;
  return await axiosROW.get(`/details/${access_id}`);
};

// receipt-details
export const getReceiptDetails = async (id: number) => {
  return await axiosApplication.get(`/receipt-details/${id}`, {});
};
